import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonRefresher, LoadingController, ModalController, NavController, PopoverController} from '@ionic/angular';
import {select, Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import * as actionsUi from './aufgaben-berechtigungen-checklisten.actions.ui';
import {getChecklistenAufgaben, getChecklistenAufgabenFehler, getChecklistenAufgabenLaden, getSelectedAufgaben} from './aufgaben-berechtigungen-checklisten.selectors';
import {ActivatedRoute, Params} from '@angular/router';
import {takeUntil, takeWhile} from 'rxjs/operators';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {AufgabenBerechtigungenModalPage} from '../aufgaben-berechtigungen-modal/aufgaben-berechtigungen-modal.page';
import {PopoverComponentPage} from '../popover-component/popover-component.page';
import {Benutzer} from '../../../../clients/vorlagen';
import { NotificationService } from '@orga-app/providers/notification.service';
import { DocumentService } from '@orga-app/providers/document.service';

@Component({
    selector: 'app-aufgaben-berechtigungen-checklisten',
    templateUrl: './aufgaben-berechtigungen-checklisten.page.html',
})
export class AufgabenBerechtigungenChecklistenPage implements OnInit, OnDestroy {
    @ViewChild(IonRefresher, { static: false})
    private aiName = 'AufgabenBerechtigungenChecklistenPage';

    public checklistenAufgaben$: Observable<Array<ListInputItem>>;
    public checklistenAufgabenLaden$: Observable<boolean>;
    public checklistenAufgabenFehler$: Observable<boolean>;

    public selectedAufgabenIds$: Observable<Array<string>>;

    funktionsbereichId: string;

    private unsubscribe$ = new Subject();
    public alive = true;
    constructor(public navCtrl: NavController,
                private store: Store<any>,
                private activatedRoute: ActivatedRoute,
                private modalCtrl: ModalController,
                public popoverController: PopoverController,
                public loadingCtrl: LoadingController,
                private notificationService: NotificationService,
                private documentService: DocumentService,
    ) {
        this.checklistenAufgaben$ = this.store.pipe(select(getChecklistenAufgaben));
        this.checklistenAufgabenLaden$ = this.store.pipe(select(getChecklistenAufgabenLaden));
        this.checklistenAufgabenFehler$ = this.store.pipe(select(getChecklistenAufgabenFehler));

        this.selectedAufgabenIds$ = this.store.pipe(select(getSelectedAufgaben));

        this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((a: Params) => {
            this.funktionsbereichId = a['funktionsbereichId'] === 'null' ? null : a['funktionsbereichId'];
            this.store.dispatch(new actionsUi.PageLoadDataAction(this.funktionsbereichId));
        });
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.unsubscribe$.complete();
    }

    async ladeDaten() {
        this.store.dispatch(new actionsUi.PageLoadDataAction(this.funktionsbereichId));
    }

    async pageAktualisieren(event) {
        await this.ladeDaten();
        setTimeout(function() {
            event.target.complete();
        }.bind(this), 200);
    }

    aufgabenAuswaehlen(values: Array<string>) {
        this.store.dispatch(new actionsUi.SetSelectedAufgabenAction(values));
    }

    async waehleBenutzer() {
        const params = {
            veranstaltungsId: null
        };
        const modal = await this.modalCtrl.create({component: AufgabenBerechtigungenModalPage, componentProps: params});
        modal.onDidDismiss().then((data: any) => {
            if (data.data !== undefined && data.data.hinzugefuegte !== undefined && data.data.hinzugefuegte.length > 0) {
                this.store.dispatch(new actionsUi.BenutzerberechtigungenHinzufuegenAction(data.data.hinzugefuegte));
            }
        });

        await modal.present();
    }

    async selectUser(ev, user: any) {
        const popover = await this.popoverController.create({
            component: PopoverComponentPage,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true,
            componentProps: {
                user
            }
        });
        await popover.present();
        popover.onDidDismiss().then((result) => {
            if (result.data !== undefined && result.data !== null && result.data === true) {
                this.store.dispatch(new actionsUi.BenutzerberechtigungenEntfernenAction(user));
            }
        });

    }

    trackByItem(index, item: Benutzer) {
        return item.benutzer_id;
    }

    async downloadExcel() {
      const loading = await this.loadingCtrl.create({
          spinner: 'dots',
          message: 'Exceldownload für Funktionsbereich wird geladen'
      });
      await loading.present();

      const url = '/api/query/vorlagen/reporting/funktionsbereiche/' + this.funktionsbereichId +'/aufgaben-berechtigungen-benutzer/excel';
      this.documentService.getDocument(url, {}).pipe(takeWhile(() => this.alive)).pipe(takeUntil(this.unsubscribe$))
          .subscribe(async (document) => {
                  if (document != null) {
                      // console.log('loaded');
                      await loading.dismiss();

                      const date = new Date();
                      const month: number = <number>date.getMonth() + 1;
                      this.documentService.saveFile(document, 'Funktionsbereich-Aufgaben-Berechtigungen' + date.getFullYear() + '-' + month + '-' + date.getDate());
                  }
              },
              error => {
                  this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                  loading.dismiss();
              }, () => {
              });
  }
}
